export default __webpack_public_path__ + "7c279e5fb8ea6349fddde21305b1e432.svg";